export default function ImpressumAndD() {
  return (
      <details id="impressum-datenschutz">
        <summary>Impressum und Datenschutz</summary>
        <p>
          <strong>Impressum:</strong>
        </p>
        <ol>
          <li>Oliver Herlemann</li>
          <li>E-Mail: info@quizrunde.com</li>
          <li>Wurmbergstr. 29</li>
          <li>71063 Sindelfingen</li>
          <li>Germany</li>
        </ol>
        <p>
          <strong>Datenschutzerklärung:</strong>
        </p>
        <ol>
          <li>
            <strong>Verantwortlicher:</strong>
            <br />
            Oliver Herlemann
            <br />
            Wurmbergstr. 29
            <br />
            71063 Sindelfingen
            <br />
            E-Mail: info@quizrunde.com
          </li>
          <br />

          <li>
            <strong>Hosting & Server-Logfiles:</strong>
            <br />
            Unsere Website wird bei{" "}
            <strong>ALL-INKL.COM – Neue Medien Münnich GmbH</strong> betrieben.
            <br />
            Beim Aufrufen der Website werden automatisch sogenannte
            Server-Logfiles gespeichert (z.&nbsp;B. IP-Adresse, Datum/Uhrzeit,
            aufgerufene Seite, Browsertyp, Betriebssystem).
            <br />
            Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO zur
            Sicherstellung von Betrieb, Sicherheit und Stabilität der Website.
            <br />
            Die Daten werden maximal <strong>7 Tage</strong> gespeichert und
            anschließend gelöscht. Eine Auswertung zu Marketingzwecken findet
            nicht statt.
          </li>
          <br />

          <li>
            Zur Speicherung Ihrer Cookie-Einwilligung nutzen wir localStorage Ihres Browsers. Dieser Speicher enthält keine Tracking-Daten und wird nicht an Dritte übertragen.
            <br/>
          </li>

          <br/>
          <br/>
          <li>
            <strong>Cookies & Analyse-Tools (Google Analytics):</strong>
            <br />
            Diese Website verwendet <strong>Google Analytics 4</strong>, einen
            Webanalysedienst der Google Ireland Limited, Gordon House, Barrow
            Street, Dublin 4, Irland.
            <br />
            <br />
            Wir nutzen <strong>Google Analytics 4</strong>, um zu verstehen, wie
            unsere Quiz-App genutzt wird (z.&nbsp;B. Start, Fortschritt,
            Ergebnisse).
            <br />
            <br />
            Google Analytics wird{" "}
            <strong>nur nach Ihrer ausdrücklichen Einwilligung</strong> aktiviert
            (Art. 6 Abs. 1 lit. a DSGVO). Ohne Ihre Zustimmung werden keinerlei
            Cookies gesetzt und keine Daten übertragen.
            <br />
            <br />
            Bei Einwilligung werden folgende Daten erhoben:
            <br />
            – Seitenaufrufe und Interaktionen innerhalb der Quiz-App
            <br />
            – Anonymisierte IP-Adresse (IP-Anonymisierung aktiviert)
            <br />
            – Browsertyp, Gerätekategorie, ungefährer Standort (Stadt/Land)
            <br />
            – Verweildauer und Nutzungsverhalten
            <br />
            <br />
            Die dabei gesetzten Cookies (<code>_ga</code>, <code>_gid</code>)
            haben eine Laufzeit von bis zu <strong>2 Jahren</strong> bzw.{" "}
            <strong>24 Stunden</strong>. Daten können in die USA übertragen
            werden; Google ist unter dem EU-U.S. Data Privacy Framework
            zertifiziert.
            <br />
            <br />
            <strong>Widerruf:</strong> Sie können Ihre Einwilligung jederzeit
            widerrufen, indem Sie auf den 🍪-Button unten rechts klicken und
            „Ablehnen" wählen. Nach dem Widerruf werden bestehende
            Analytics-Cookies gelöscht und kein neues Tracking gestartet.
            <br />
            <br />
            Weitere Informationen:{" "}

            <a href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            >
            Google Datenschutzerklärung
          </a>
        </li>
        <br />

        <li>
          <strong>Eingebundene Medien / Inhalte:</strong>
          <br />
          Die Website verwendet lokal eingebundene Medien (Sounds und Bilder).
          Es findet <strong>keine Übertragung an externe Server</strong> statt
          (außer bei aktiviertem Google Analytics, siehe oben).
          <br />
          <br />
          <strong>Quellen:</strong>
          <br />
          – Soundeffekte (richtige Antwort & Sieges-Fanfaren) sowie der goldene
          Pokal: Pixabay.com
          <br />
          – Soundeffekt „Gameshow quiz incorrect buzzer": Zapsplat.com
        </li>
        <br />

        <li>
          <strong>Verarbeitung personenbezogener Daten:</strong>
          <br />
          Abgesehen von Server-Logfiles und – bei Einwilligung – Google
          Analytics werden{" "}
          <strong>keine personenbezogenen Daten</strong> gespeichert,
          verarbeitet oder weitergegeben. Die Website enthält:
          <br />
          – kein Kontaktformular
          <br />
          – keine Benutzerkonten
          <br />
          – keine extern geladenen Schriftarten (z.&nbsp;B. Google Fonts)
          <br />
          – keine Social-Media-Plugins
        </li>
        <br />

        <li>
          <strong>Rechte der Nutzer:</strong>
          <br />
          Nutzer haben folgende Rechte gemäß DSGVO:
          <br />
          – Auskunft (Art. 15 DSGVO)
          <br />
          – Berichtigung (Art. 16 DSGVO)
          <br />
          – Löschung (Art. 17 DSGVO)
          <br />
          – Einschränkung der Verarbeitung (Art. 18 DSGVO)
          <br />
          – Widerspruch (Art. 21 DSGVO)
          <br />
          – Datenübertragbarkeit (Art. 20 DSGVO)
          <br />
          Anfragen können an die oben genannte Kontaktadresse gestellt werden.
        </li>
        <br />

        <li>
          <strong>Änderungen dieser Datenschutzerklärung:</strong>
          <br />
          Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf
          anzupassen. Stand: Juni 2025.
        </li>
      </ol>
</details>
);
}